import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0bfe546f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-component p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-col-3" }
const _hoisted_3 = { style: {"font-size":"1rem"} }
const _hoisted_4 = { class: "p-field p-input-filled p-col-9" }
const _hoisted_5 = {
  key: 0,
  class: "p-error"
}
const _hoisted_6 = { class: "p-col-3" }
const _hoisted_7 = { style: {"font-size":"1rem"} }
const _hoisted_8 = { class: "p-col-9" }
const _hoisted_9 = { class: "p-field p-input-filled p-inputgroup" }
const _hoisted_10 = { class: "p-col-3" }
const _hoisted_11 = { style: {"font-size":"1rem"} }
const _hoisted_12 = { class: "p-col-9" }
const _hoisted_13 = { class: "p-field p-input-filled p-inputgroup" }
const _hoisted_14 = { class: "p-col-3" }
const _hoisted_15 = { style: {"font-size":"1rem"} }
const _hoisted_16 = { class: "p-field p-input-filled p-col-9" }
const _hoisted_17 = { class: "p-col-3" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = { class: "inner-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_FormHeadTrainingTable = _resolveComponent("FormHeadTrainingTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.trainingKey.description), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_InputText, {
          type: "text",
          modelValue: _ctx.trainingKey.value.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.trainingKey.value.value) = $event)),
          disabled: ""
        }, null, 8, ["modelValue"]),
        (!(_ctx.trainingKey.value.value !== '' && _ctx.trainingKey.value.value !== null))
          ? (_openBlock(), _createElementBlock("small", _hoisted_5, _toDisplayString(_ctx.$t("Squeeze.Training.TrainingKey")), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("Squeeze.Training.Description")), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_InputText, {
            type: "text",
            modelValue: _ctx.regionAnchor.description,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.regionAnchor.description) = $event))
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t("Squeeze.Training.KeyWord")), 1)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_InputText, {
            type: "text",
            modelValue: _ctx.regionAnchor.keyWordPattern,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.regionAnchor.keyWordPattern) = $event)),
            onFocus: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onFocusField('regionAnchorKeyWordPattern')))
          }, null, 8, ["modelValue"]),
          _createVNode(_component_Button, {
            class: "active",
            icon: "mdi mdi-auto-fix",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onFocusField('regionAnchorKeyWordPattern')))
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t("Squeeze.Training.IgnoreSpaces")), 1)
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_Dropdown, {
          modelValue: _ctx.regionAnchor.ignoreWhiteSpaces,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.regionAnchor.ignoreWhiteSpaces) = $event)),
          options: _ctx.booleanOptions,
          optionLabel: "name",
          optionValue: "id"
        }, null, 8, ["modelValue", "options"])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_Button, {
          label: _ctx.regionAnchor.id ? _ctx.$t('Squeeze.Training.Retrain') : _ctx.$t('Squeeze.Training.Train'),
          disabled: (!(_ctx.regionAnchor.keyWordPattern !== '' && _ctx.regionAnchor.keyWordRegion && _ctx.trainingKey.value.value !== '' && _ctx.trainingKey.value.value !== null)),
          onClick: _ctx.trainRegionAnchor
        }, null, 8, ["label", "disabled", "onClick"])
      ])
    ]),
    _hoisted_18,
    _createElementVNode("div", _hoisted_19, [
      _createVNode(_component_FormHeadTrainingTable, {
        tableOrigin: "regionAnchors",
        tableData: _ctx.allRegionAnchors,
        loading: _ctx.loading,
        onChangeData: _ctx.changeRegionAnchor,
        onDeleteData: _ctx.deleteRegionAnchor,
        onOnMarkRegion: _ctx.onMarkRegion
      }, null, 8, ["tableData", "loading", "onChangeData", "onDeleteData", "onOnMarkRegion"])
    ])
  ], 64))
}